import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sistrix': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 449l-30.5 31-146-148.1c-28.7 23.7-65.2 37.9-105 37.9-91.8 0-166.5-75.8-166.5-168.9 0-93.1 74.7-168.9 166.6-168.8 91.8 0 166.5 75.8 166.5 168.9 0 37-11.9 71.3-31.9 99.2zM166.5 330.8c70.7 0 128.1-58.3 128.1-129.9 0-71.6-57.5-129.9-128.1-129.9s-128.1 58.3-128.1 129.9c0 71.6 57.5 129.9 128.1 129.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/sistrix.js
// module id = 1011
// module chunks = 0